import { useEffect, useState } from 'react';
import Image from 'next/image';
import { Translate, useTranslate } from '~/i18n';
import { Section } from '~/components/common/section';
import { Button } from '~/components/common/button';
import { PayoutIcon } from '~/svgs';
import BnplSetupModal from './bnpl-setup-modal';
import BnplOtpModal from './bnpl-otp-modal';
import { useAuth } from '~/auth';

const BnplInfoCard = ({
   isBnplActive,
   refetchBnplStatus,
   tabbyServiceRate,
   tamaraServiceRate,
}: {
   isBnplActive?: boolean;
   refetchBnplStatus: () => void;
   tabbyServiceRate: string;
   tamaraServiceRate: string;
}) => {
   const { lang } = useTranslate();
   const { user } = useAuth();

   const [showBnplPopup, setShowBnplPopup] = useState(false);
   const [showVerifyPopup, setShowVerifyPopup] = useState(false);
   const [tamara, setTamara] = useState<boolean>(false);
   const [tabby, setTabby] = useState<boolean>(false);

   useEffect(() => {
      if (user) {
         setTamara(user.tamara_active ?? false);
         setTabby(user.tabby_active ?? false);
      }
   }, [user]);

   return (
      <Section className="border rounded">
         <div className="px-8 py-2">
            <span className="font-semibold">
               <Translate id="bnpl:buy now pay later" />
            </span>
         </div>
         <hr />
         <div className="flex flex-col items-center justify-between gap-3 px-8 py-4 md:flex-row">
            <div className="flex gap-3">
               <span>
                  <PayoutIcon className="[&>*]:fill-black mt-1.5" width={20} height={20} />
               </span>
               <div className="flex flex-col">
                  <span className="font-semibold">
                     <Translate id="bnpl:setup bnpl title" />
                  </span>
                  <span className="text-xs">
                     <Translate id="bnpl:setup bnpl subtitle" />
                  </span>
                  <div className="flex gap-3 pt-3">
                     <div>
                        <Image priority width={56} height={25} src={`/images/brands/tabby.svg`} />
                     </div>
                     <div>
                        <Image
                           priority
                           width={56}
                           height={25}
                           src={`/images/brands/tamara-${lang || 'en'}.svg`}
                        />
                     </div>
                  </div>
               </div>
            </div>
            <Button
               className="h-12 gap-3"
               theme="outline-primary"
               onClick={() => {
                  setShowBnplPopup(true);
               }}>
               <>
                  <Translate id="bnpl:setup buy now pay later" />
               </>
            </Button>
         </div>
         <BnplSetupModal
            open={showBnplPopup}
            onClose={(showOtpForm?: boolean) => {
               setShowBnplPopup(false);
               if (showOtpForm) {
                  setShowVerifyPopup(true);
               }
            }}
            isBnplActive={isBnplActive}
            tabbyServiceRate={tabbyServiceRate}
            tamaraServiceRate={tamaraServiceRate}
            tabby={tabby}
            setTabby={setTabby}
            tamara={tamara}
            setTamara={setTamara}
         />
         <BnplOtpModal
            open={showVerifyPopup}
            onClose={() => {
               refetchBnplStatus();
               setShowVerifyPopup(false);
            }}
            isBnplActive={isBnplActive}
            tabby={tabby}
            tamara={tamara}
         />
      </Section>
   );
};

export default BnplInfoCard;
